var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HmwControl',{on:{"subcommand":_vm.subcommand}}),_vm._v(" "),_c('TimerControl',{on:{"subcommand":_vm.subcommand}}),_vm._v(" "),_c('TeamStatusControl',{attrs:{"subject":_vm.slide.settings.subject,"type":"answers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }